import type { components } from "@/api/contract";

export type MultiUsageSummary = components["schemas"]["MultiUsageSummary"];
export type ResourceUsage = components["schemas"]["ResourceUsage"];
export type ResourceType = ResourceUsage["resource_type"];

/** Sentinel the backend uses for an unmetered allowance (`total`/`left` = -1). */
export const UNLIMITED = -1;

/** The first matching resource in a usage summary, or undefined. */
export function findResource(
  summary: MultiUsageSummary,
  type: ResourceType,
): ResourceUsage | undefined {
  return summary.resources.find((r) => r.resource_type === type);
}

/** True when the resource has no cap (e.g. unlimited basic requests on Pro). */
export function isUnlimited(resource: ResourceUsage): boolean {
  return resource.total === UNLIMITED || resource.left === UNLIMITED;
}

/**
 * Percentage of the allowance consumed, clamped to 0–100. Returns null when the
 * resource is unlimited or has no positive total (nothing to render a bar for).
 */
export function percentUsed(resource: ResourceUsage): number | null {
  if (isUnlimited(resource) || resource.total <= 0) return null;
  return Math.min(100, Math.max(0, Math.round((resource.used / resource.total) * 100)));
}
